import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeGetReceivingProgressItemIssueImagesParams,
  TypeGetReceivingProgressItemIssueImagesResponse,
} from '~/types/receive.types';

const fetchReceivingProgressItemIssueImages = async ({
  ownerCode,
  requestId,
  requestItemId,
}: TypeGetReceivingProgressItemIssueImagesParams): Promise<TypeGetReceivingProgressItemIssueImagesResponse> => {
  const { data } = await axiosInstance.get<TypeGetReceivingProgressItemIssueImagesResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/progress/${requestId}/items/${requestItemId}/issue-images`
  );
  return data;
};

/**
 * [입고관리 > 입고현황] 입고 현황 상세 > 이슈 이미지 조회 Mutation Hook
 */
export const useGetReceivingProgressItemIssueImagesMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingProgressItemIssueImages,
  });
};

registerMockAPI<TypeGetReceivingProgressItemIssueImagesResponse>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/progress/:requestId/items/:requestItemId/issue-images',
  label: '입고/입고현황/이슈이미지',
  scenarios: [
    {
      name: '정상 응답 (이미지 3장)',
      response: {
        data: {
          issueImages: [
            {
              requestItemId: 38586,
              inspectionHeaderId: 12367,
              fileId: 10132,
              filePath:
                'https://s3.ap-northeast-2.amazonaws.com/rms.dev.kurly.com/preview/%5Bissue-image-12367%5D%202025-08-27%2016%3A45%3A07%3A622.png',
            },
            {
              requestItemId: 38586,
              inspectionHeaderId: 12367,
              fileId: 10129,
              filePath:
                'https://s3.ap-northeast-2.amazonaws.com/rms.dev.kurly.com/preview/%5Bissue-image-12367%5D%202025-08-27%2016%3A42%3A26%3A887.jpg',
            },
            {
              requestItemId: 38586,
              inspectionHeaderId: 12367,
              fileId: 10128,
              filePath:
                'https://s3.ap-northeast-2.amazonaws.com/rms.dev.kurly.com/preview/%5Bissue-image-12367%5D%202025-08-27%2016%3A42%3A29%3A646.png',
            },
          ],
        },
      },
    },
    {
      name: '빈 응답 (이슈 이미지 없음)',
      response: { data: { issueImages: [] } },
    },
    {
      name: '유효하지 않은 고객사 (9000)',
      response: {
        error: {
          code: 9000,
          message: '유효하지 않은 고객사입니다.',
        },
      },
      status: 400,
    },
  ],
});
